export default __webpack_public_path__ + "static/media/landing-video-poster.a16fdab6.PNG";